"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.default = (function (option, dayjsClass) {
    dayjsClass.prototype.formatNumerals = function (format, locale) {
        var toCustomNumerals;
        switch (locale) {
            case 'ar':
                toCustomNumerals = function (number) {
                    return number.toString().replace(/\d/g, function (d) {
                        return '۰۱۲۳۴۵۶۷۸۹'[+d];
                    });
                };
                break;
            default:
                toCustomNumerals = function (number) { return number.toString(); };
        }
        var FORMATED = this.format(format);
        return toCustomNumerals(FORMATED);
    };
});
